export default __webpack_public_path__ + "static/logo-footer-7c2c325a18e805911fc36b7899a220b2.svg";